import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  HashRouter,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Pages/LoginPage/LoginPage";
import SignUpPage from "./Pages/SignUp/SignUp";
import StripePaymentPage from "./Pages/Payment/payment";
import ProductsPage from "./Pages/ProductsPage/ProductsPage";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";
import DonationDetailsPage from "./Pages/DonationDetailsPage/DonationDetailsPage";
import RecurringPlansPage from "./Pages/RecurringPlansPage/RecurringPlansPage";
import WaqfDetailsPage from "./Pages/WaqfDetailspage/WaqfDetailsPage";
import RecurPlanDetailsPage from "./Pages/RecurPlanDetailsPage/RecurPlanDetailsPage";
import DashboardPage from './Pages/DashboardPage/DashboardPage';

import "./App.css";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState({ email_id: "" });

  useEffect(() => {
    window.catalyst.auth
      .isUserAuthenticated()
      .then((result) => {

        const username = result.content.email_id;
        const firstName = result.content.first_name;
        const lastName = result.content.last_name;

        setUserDetails({
          email_id: username,
          fName: firstName,
          lName: lastName,
        });
        setIsAuthenticated(true);
      })
      .catch(() => {
        setIsAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center align-middle mt-[20%]">
        <div className="animate-spin w-12 h-12 border-[4px] rounded-[50%] border-l-[#095856] border-[black]"></div>
      </div>
    );
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/SignUpPage" element={<SignUpPage />} />

        <Route path='/dashboard' element={isAuthenticated?(
        <DashboardPage />
      ):(
        <Navigate to= "/login" replace/>)}
      />
        <Route
          path="/subscription"
          element={
            isAuthenticated ? (
              <ProductsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/donationDetails"
          element={
            isAuthenticated ? (
              <DonationDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/WaqfDetails"
          element={
            isAuthenticated ? (
              <WaqfDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/RecurringPlans"
          element={
            isAuthenticated ? (
              <RecurringPlansPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/plansdetail"
          element={
            isAuthenticated ? (
              <RecurPlanDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/PaymentPage"
          element={
            isAuthenticated ? (
              <StripePaymentPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/profile"
          element={
            isAuthenticated ? <ProfilePage /> : <Navigate to="/login" replace />
          }
        />
        <Route path="/" element={isAuthenticated ? <Navigate replace to="/subscription" /> : <Navigate replace to="/login" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
